import Generic from '../Generic';

export default Object.assign({}, Generic, {
  background: require('./images/Global_bkg.jpg'),
  ipg_background: require('./images/IPG_bkg.jpg'),
  menu_background: require('./images/Main_bkg.jpg'),
  welcome_background: require('./images/PromoCh_bkg.jpg')
});
